import { getAssets } from '../../../data/repositories/businessRepository.js';

/**
 * Fetch assets for a business
 * @param {string} businessId - The business ID
 * @returns {Promise<Array>} List of assets with title, images, and description
 */
export const fetchAssets = async (businessId) => {
  if (!businessId) return [];
  const response = await getAssets(businessId);
  return Array.isArray(response) ? response : response.data || [];
};
